import { render, staticRenderFns } from "./RaceRecordingView.vue?vue&type=template&id=5486e522"
import script from "./RaceRecordingView.vue?vue&type=script&lang=js"
export * from "./RaceRecordingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports